export default __webpack_public_path__ + "static/media/tapeOneMobile.17084675.svg";